export class Responsibilty {
    Id: number;
    Name: string;
}
export class EditResponsibilty {
    ProjectId: number;
    ProjectResponsibilityId: number;
}
